import "react-datepicker/dist/react-datepicker.css";
import logo from "../../assests/logo_blackbg.png";
import Footer from "../Layout/Footer";
import Header from "../login/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Blocked = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const signout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <Header />
      <div
        className={"container grid grid--1--cols"}
        style={{ justifyItems: "center", marginBottom: "2.4rem" }}
      >
        <img src={logo} alt="bethlehem" style={{ width: 250 }} />
        <p
          style={{
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          <p> الرجاء التواصل مع مكتب التسجيل على:</p>
          <p
            style={{
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold",
              direction: "rtl",
            }}
          >
            {" "}
            <p style={{ direction: "ltr" }}>+970 (0)2-274-1241 Ext: 2219</p> أو
            admission@bethlehem.edu{" "}
          </p>
          <p>لاستكمال هذا الطلب</p>
        </p>
        <p
          style={{
            textAlign: "center",
            fontSize: "20px",
            direction: "ltr",
            fontWeight: "bold",
          }}
        >
          <p>Please follow up with the Registrar office at:</p>
          <p> +970 (0)2-274-1241 Ext: 2219 </p>
          <p>or admission@bethlehem.edu</p>
          <p> in order to complete this application</p>
        </p>
        <button onClick={signout} className={"btn redbutton"}>
          {t("Signout")}
        </button>
      </div>
      <Footer />
    </>
  );
};

export default Blocked;
